module.exports = __webpack_public_path__ + "img/personal-okr.e1eabdd3.svg";